<template>
    <div v-if="showTag" class="">
        <div class="main fixed bg_fff t0 b0 flex column oh" :style="style" ref="main">
            <h3 class="color_fff bg_555 fs14 pl15 pr15 pt10 pb10 flex aic flex0" style="cursor: move" v-drag>
                <span class="flex1">正在通话中...</span>
                <div class="flex0 flex">
                    <span class="el-icon-close fs18 flex0 pointer" @click="hide"></span>
                </div>
            </h3>
            <div class="videowrap relative flex0" :style="videoStyle">
                <video class="absolute l0 t0" ref="remoteVideo" :style="videoStyle" autoplay controls></video>
                <audio ref="remoteAudio" autoplay></audio>
                <ul class="mini absolute r0 t0 flex">
                    <li>
                        <video :style="miniVideoStyle" autoplay controls muted ref="local"></video>
                    </li>
                </ul>
            </div>
            <!--<message-box class="flex1 oh flex column" ref="msgBox" :list="msglist" blank="30"></message-box>-->
            <dis_message_box class="flex1 oh flex column" ref="msgBox"></dis_message_box>
            <video-tool-bar class="" @handler="handler" :share="false"></video-tool-bar>
            <send-msg-box-simple @send="send" ref="sendMsgBox" class="flex0"></send-msg-box-simple>
            <share-dialog ref="shareRoomDialog"></share-dialog>
            <dis_msg_load ref="ImgLoad" v-show="false" @succ="succ"></dis_msg_load>
        </div>
    </div>
</template>
<style scoped>
    .mask {
        z-index: 1000;
    }

    .main {
        z-index: 1001;
    }

</style>
<script>
    import {videoDialogDragDirective} from "../../lib/directives/video-dialog-drag";
    import MessageBox from "../common/message-box";
    import SendMsgBoxSimple from "../common/send-msg-box-simple";
    import VideoToolBar from "../common/video-tool-bar"
    import ShareDialog from "../common/share-room-dialog"
    import {tee3mixin} from "../../lib/video/tee3mixin";
    import {disService} from "../../lib/service/dis";
    import dis_message_box from "../../components/dis/dis-message-box"
    import dis_msg_load from "../../components/dis/dis-msg-load"

    export default {
        name: "dis-video-dialog",
        directives: {
            drag: videoDialogDragDirective
        },
        components: {SendMsgBoxSimple, dis_message_box, VideoToolBar, ShareDialog,dis_msg_load},
        mixins: [tee3mixin],
        props: {
            id: {
                type: String,
                default: ''
            },
        },
        data() {
            return {
                point: {
                    canMove: false,
                    start: {},
                    origin: {},
                    move: {},
                    deltaX: 0,
                    deltaY: 0
                },
                W: 0,
                msglist: [],
                page: {},
                room: null,
                showTag: false,
                timer: null,
                userId:""
            }
        },
        computed: {
            width() {
                return this.W / 3;
            },
            videoStyle() {
                const width = this.width;
                return {
                    width: `100%`,
                    height: `${width / 4 * 3}px`
                }
            },
            miniVideoStyle() {
                const width = this.width;
                return {
                    width: `${width / 5}px`,
                    height: `${width / 4 * 3 / 2 - 10}px`
                }
            },
            style() {
                const width = this.width;
                return {
                    top: '0px',
                    left: `${this.W / 2}px`,
                    marginLeft: `${0 - width / 2}px`,
                    width: `${width}px`
                };
            }
        },
        created() {
            bus.$on('leaveSuccess', () => {
                this.showTag = false;
            });
            // bus.$on('updateScreen',this.updateScreen)
            //屏幕共享回调事件
            bus.$on('onSubscribleScreenResult', this.updateScreen);
            bus.$on('onSubscribleCameraResult', this.addCameraResult);
            bus.$on('unScreenResult',this.findUserVideo);
            //bus.$on('onSubscribleCameraResult', this.updateVideo);
            this.W = document.body.clientWidth;
        },
        mounted() {
            this.$nextTick(() => {
                document.body.appendChild(this.$el);
            })
        },
        beforeDestroy() {
            bus.$off('onSubscribleScreenResult');
            bus.$off('onSubscribleCameraResult');
            bus.$off('unScreenResult');
            this.clearTimer();
        },
        methods: {
            findUserVideo(){
               const obj =  this.findVideo(this.userId,'video');
               this.$refs.remoteVideo.srcObject = obj.stream;
            },
            addCameraResult(stream, userId, userName, cameraId){
                this.userId = userId;
                this.updateOrAddVideo({stream, userId, userName, cameraId,type:'video'});
            },
            updateScreen(stream, userId,userName, screenId){
                Log('remoteVideo', this.$refs.remoteVideo);
                this.$refs.remoteVideo.srcObject = stream;
            },
            updateVideo(stream, userId, userName, cameraId){
                Log('remoteVideo', this.$refs.local);
                this.$refs.local.srcObject = stream;
            },
            // updateScreen({type, stream, userId, cameraId}){
            //     if (type === 'screen') {
            //         Log('remoteVideo', this.$refs.remoteVideo);
            //         this.$refs.remoteVideo.srcObject = stream;
            //     }
            // },
            async show(room) {
                this.room = room;
                this.showTag = true;
                await this.getMsgList();
                await this.tee3enterRoom(room.token);
            },
            hide() {
                this.$confirm('是否退出房间', '提示', {}).then(async () => {
                    this.clearTimer();
                    await this.tee3leaveRoom();
                    this.showTag = false;
                });
            },
            //获取消息列表
            async getMsgList() {
                this.$nextTick(() => {
                    this.$refs['msgBox'].getMsg(this.id);
                })
                this.clearTimer();
                this.timer = setTimeout(this.getMsgList, 5000);
                // const {list, page} = await disService.getMsgList({
                //     outpatientId: this.id
                // });
                // this.msglist = list;
                // page.total !== this.page.total && this.$nextTick(() => {
                //     this.page = page;
                //     this.$refs.msgBox && this.$refs.msgBox.toEnd();
                // });
                // this.clearTimer();
                // this.timer = setTimeout(this.getMsgList, 5000);
            },
            clearTimer() {
                if (this.timer) {
                    clearTimeout(this.timer);
                    this.timer = null;
                }
            },
            //发送消息
            async send(content) {
                if (await disService.reply({
                    outpatientId: this.id,
                    msgContent: content
                })) {
                    await this.getMsgList();
                    this.$refs.sendMsgBox.clear();
                }
            },
            handlerRemoteMedia({type, stream, userId, cameraId}) {
                Log('media', {type, stream, userId, cameraId})
                if (type === 'video') {
                    Log('remoteVideo', this.$refs.remoteVideo);
                    this.$refs.remoteVideo.srcObject = stream;
                }
                if (type === 'audio') {
                    Log('remoteAudio', this.$refs.remoteAudio);
                    this.$refs.remoteAudio.srcObject = stream;
                }
            },
            async handler(type){
                if(type==='邀请讨论'){
                    this.$message.error('功能暂未开放');
                   // this.$refs.shareRoomDialog.show()
                }

                if(type == '图片'){
                    this.$refs.ImgLoad.start(this.id);
                }

                if(type == '文件传输'){
                    this.$refs.ImgLoad.startFile(this.id);
                }

                if(type == '桌面分享'){
                    const that = this;
                    await this.openScreenAndPub(this.$refs['local']);
                    setTimeout(()=>{
                       that.checkScreenOutSelfUser(this.$refs['local']);
                    },5000)
                }

                if(type == '白板'){
                    this.$emit('openBank');
                }
            },
            async succ(){
                await this.getMsgList();
            }
        },
    }
</script>
